module.exports = __webpack_public_path__ + "media/images/logo-dark-4cee67876f0f893fc310a2058d7ec565.svg";